<nav class="navbar navbar-dark sticky-top bg-dark flex-md-nowrap p-0 shadow">
    <div class="d-flex w-100 justify-content-between align-items-center"> 
        @if (tokenService.isLogged()) {
            <button class="navbar-toggler d-md-none border-0 px-3" 
                    type="button" 
                    aria-controls="sidebarOffcanvas"
                    aria-label="Toggle navigation"
                    (click)="toggleSidebar()">
                <span class="navbar-toggler-icon"></span>
            </button>
        } @else {
            <div class="px-3">
                <span class="navbar-toggler-icon invisible"></span>
            </div>
        }
        <a class="navbar-brand me-0 px-3 text-start" href="#">
            <img src="assets/images/logo_blue.png" alt="Staff It Easy Logo" style="height: 30px;">
        </a>
        <div class="px-3">
            @if (tokenService.isAdmin()) {
                <ul class="nav nav-pills mb-auto">
                    <li>
                        <a class="nav-link text-white p-0" 
                            routerLink="/admin" 
                            routerLinkActive="active" 
                            [routerLinkActiveOptions]="{ exact: false }">
                            <i class="bi-shield-shaded fs-3"></i>
                        </a>
                    </li>
                </ul>
            } @else {
                <span class="navbar-toggler-icon invisible"></span>
            }
        </div>
    </div>
</nav>